"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataError = exports.isNonExportableError = void 0;
// (C) 2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_ext_1 = require("@gooddata/sdk-ui-ext");
var util_1 = require("@gooddata/util");
/**
 * Returns true if the provided error should prevent exports.
 *
 * @remarks Some errors are still ok with respect to exports (e.g. negative values in a pie chart) and these
 * should not prevent exports. However, errors detected by this function really make potential exports
 * nonsensical and should lead to exports being disabled.
 *
 * @internal
 */
exports.isNonExportableError = util_1.typesUtils.combineGuards(sdk_ui_1.isUnknownSdkError, sdk_ui_1.isBadRequest, sdk_ui_1.isNoDataSdkError, sdk_ui_1.isProtectedReport, sdk_ui_1.isDataTooLargeToCompute, sdk_ui_ext_1.isEmptyAfm);
/**
 * @internal
 */
exports.isDataError = util_1.typesUtils.combineGuards(sdk_ui_1.isUnknownSdkError, sdk_ui_1.isBadRequest, sdk_ui_1.isNoDataSdkError, sdk_ui_1.isDataTooLargeToCompute, sdk_ui_1.isDataTooLargeToDisplay, sdk_ui_1.isProtectedReport, sdk_ui_ext_1.isEmptyAfm, sdk_ui_1.isNegativeValues);
//# sourceMappingURL=errorPredicates.js.map